export default "__VITE_ASSET__PeJYSPp7__"